import { Box, Divider } from "@material-ui/core";
import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  mobileGlobe: {
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  desktopGlobe: {
    display: "none",
    [theme.breakpoints.up("lg")]: {
      display: "flex",
    },
  }
}));



export const DLACard = (props: any) => {
  const classes = useStyles()
  return (
    <>
      <Grid
        container
        display="flex"
        direction={{
          lg: props.reverse ? "row-reverse": "row",
          xs: "column-reverse",
        }}
        justifyContent="center"
        alignItems="center"
        paddingBottom={2}
        paddingTop={props.first? 0: 2}
      >
        <Grid
          item
          xs={12}
          lg={props.reverse? 2:4}
          justifyContent={{ lg: "center", xs: "center" }}
          className={classes.desktopGlobe}
        >
          {props.globe}
        </Grid>

        <Grid 
        paddingRight={{lg: props.reverse? 0: 5, xs:0}}
        paddingLeft={{lg: props.reverse? 5:0, xs: 0}} 
        width={{lg:'auto',sm: '50%', xs:'100%'}} 
        display="flex" 
        justifyContent="flex-start" 


        item xs={12} lg={props.reverse? 7: 6}>

          {props.para}
        </Grid>

        <Grid
          item
          xs={12}
          lg={2}
          paddingY={{lg:0, xs: 5}}
          justifyContent={{ lg: "flex-start", xs: "space-between", sm:"space-evenly" }}
          display="flex"
          flexDirection={props.reverse ? "row-reverse": "row"}
          alignItems="center"
          minWidth={{xs:"100%", lg: "auto"}}
        >
          <Box className={classes.mobileGlobe}>
          {props.globe}
          </Box>
          {props.num}
        </Grid>
      

      </Grid>

      {!props.end && (
        <Divider
          style={{
            backgroundColor: "#4D4D4D",
            // borderStyle: "solid",
            // marginRight: 80,
            // marginLeft: 80,
            marginTop: 20,
            marginBottom: 20,
          }}
          orientation="horizontal"
        />
      )}
    </>
  );
};
